import styled from 'styled-components';

export const CartPreviewItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
  padding-bottom: 8px;
`;
